/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryIntermediaryDetails
 */
export interface ProposalSummaryIntermediaryDetails {
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    nameAndSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    pRINumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    isAdvising: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    isServicing: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    annualFeeSplitPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    lumpSumFeeSplitPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryIntermediaryDetails
     */
    recurringFeeSplitPercentage?: number;
}

/**
 * Check if a given object implements the ProposalSummaryIntermediaryDetails interface.
 */
export function instanceOfProposalSummaryIntermediaryDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isAdvising" in value;
    isInstance = isInstance && "isServicing" in value;

    return isInstance;
}

export function ProposalSummaryIntermediaryDetailsFromJSON(json: any): ProposalSummaryIntermediaryDetails {
    return ProposalSummaryIntermediaryDetailsFromJSONTyped(json, false);
}

export function ProposalSummaryIntermediaryDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryIntermediaryDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'Code') ? undefined : json['Code'],
        'nameAndSurname': !exists(json, 'NameAndSurname') ? undefined : json['NameAndSurname'],
        'pRINumber': !exists(json, 'PRINumber') ? undefined : json['PRINumber'],
        'isAdvising': json['IsAdvising'],
        'isServicing': json['IsServicing'],
        'annualFeeSplitPercentage': !exists(json, 'AnnualFeeSplitPercentage') ? undefined : json['AnnualFeeSplitPercentage'],
        'lumpSumFeeSplitPercentage': !exists(json, 'LumpSumFeeSplitPercentage') ? undefined : json['LumpSumFeeSplitPercentage'],
        'recurringFeeSplitPercentage': !exists(json, 'RecurringFeeSplitPercentage') ? undefined : json['RecurringFeeSplitPercentage'],
    };
}

export function ProposalSummaryIntermediaryDetailsToJSON(value?: ProposalSummaryIntermediaryDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Code': value.code,
        'NameAndSurname': value.nameAndSurname,
        'PRINumber': value.pRINumber,
        'IsAdvising': value.isAdvising,
        'IsServicing': value.isServicing,
        'AnnualFeeSplitPercentage': value.annualFeeSplitPercentage,
        'LumpSumFeeSplitPercentage': value.lumpSumFeeSplitPercentage,
        'RecurringFeeSplitPercentage': value.recurringFeeSplitPercentage,
    };
}

